/**
 * Where a public page's "start" button goes — ONE rule, used by today's page and by its rebuild in the new design, so
 * the two can never send a visitor to different places (PV4, design record §7b).
 *
 * A signed-in visitor goes to the app (`/`). A signed-out one goes where THAT page has always sent them: the page for
 * lawyers to `/start`, the page for individuals to `/auth`. The destination is the page's own, passed in — this
 * decides only who is signed in, and reads it from the same place the pages always did (AuthContext).
 */
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function useStartAction(signedOutTo: string): () => void {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  return useCallback(() => {
    navigate(isAuthenticated ? '/' : signedOutTo);
  }, [isAuthenticated, navigate, signedOutTo]);
}
